
// Returns "(813) 781-3507" for a 10-digit US number, tolerating an 11-digit
// number with a leading 1. Anything it cannot format is returned unchanged so a
// number still renders rather than vanishing.
exports.formatPhoneNumber = (phoneNumberString) => {
    if (phoneNumberString == null) {
        return null;
    }
    const cleaned = String(phoneNumberString).replace(/\D/g, '');
    const match = cleaned.replace(/^1(?=\d{10}$)/, '').match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return String(phoneNumberString);
}

exports.formatCurrency = (cents) => {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      });

      return formatter.format(cents / 100);
}